import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UpdateCasePriorityCommand } from './update-case-priority.command';

/**
 * Update case priority use case.
 * Updates the priority of a case.
 */
@Injectable({ providedIn: 'root' })
export class UpdateCasePriorityUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the update case priority use case.
   * @param command - The command containing case ID and priority code
   * @returns Observable void
   */
  public execute(command: UpdateCasePriorityCommand): Observable<void> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository.updateCasePriority(command.caseId, command.priorityCode).pipe(
      tap(() => {
        this._state.setSavingCases(false);
      }),
      catchError((error) => {
        this._state.setErrorCases(error.message || 'Failed to update case priority');
        this._state.setSavingCases(false);
        return throwError(() => error);
      })
    );
  }
}
